import { AvailableRoutes } from '@/router/Routes.ts';

export function passToRouteUrlParams(route: AvailableRoutes, params: Record<string, string>) {
  return Object.keys(params).reduce((acc, key) => {
    return acc.replace(`:${key}`, params[key]);
  }, route);
}
